<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Service Accounts</h1>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/locked/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        <span>Locked service accounts</span>
                    </a>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/deleted/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-user-times" aria-hidden="true"></i>
                        <span>Deleted service accounts</span>
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                    <a :href="`/#/admin/organizations/users/create-service-account/${tid}`" role="button" class="btn btn-success text-white" style="padding: 0.7em 2em;">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        <span>Create service account</span>
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <p class="text-muted">Service accounts are used for API access and automation. They cannot sign in through the UI.</p>
            <UsersTable v-if="serviceAccounts.length" :users="serviceAccounts" :showActive="false"></UsersTable>
            <h4 v-else>No service accounts found</h4>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/Users/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/commands-vue-component";
    import "@common/AdminNavigationV2.vue";
    import "@Organizations/Users/Components/UsersTable.vue";

    @Component
    export default class ServiceAccountsPage extends mixins(PageBase, VuePageQueries, VuePageCommands) {
        mounted() {
            this.setTitle("Service Accounts");
            // Pass true for includeServiceAccounts to get ONLY service accounts
            this.runSearchAllUsersQueryV1(this.tid, '', true, false, false, true);
        }

        get allUsersSearchResult() { return this.model?.AllUsersSearchResult; }
        get users() { return this.allUsersSearchResult?.Users || []; }
        // No need to filter anymore since the query returns only service accounts
        get serviceAccounts() { return this.users; }
    }
</script>

<style scoped>
</style>
